


import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import {NotificationBadge, NotificationByPlaceBadge} from '../Dashboard/Notification/NotificationBadge';
import { AuthConsumer } from '../AuthContext';
import { AuthContext } from '../AuthContext';
import { useNotification } from '../Dashboard/Notification/NotificationContext';

const TabLink = ({ id, isActive, path, onClick, icon, text }) => {
const { user } = useContext(AuthContext); 
const { liveRequest,pendingRequest, liveMessages, pendingMessages} = useNotification();

  return (
    <li className="nav-item">
      <Link
        name={id}
        className={'nav-link ' + (isActive ? 'active' : '')}
        to={path}
        onClick={() => (onClick ? onClick() : null)}
      >
          {icon && <img src={icon} />} {text} 
        {user?.is_host && text === 'Bookings' && <NotificationBadge id={user?.id} />}
        {!user?.is_host && text === 'Requests' && <NotificationBadge id={user?.id} />}

        {/* {!user?.is_host && text == 'Past requests' && <NotificationByPlaceBadge count={user?.id} />} */}
        {!user?.is_host &&  liveRequest > 0 && text == 'Live requests' && <NotificationByPlaceBadge count={liveMessages} />}
        {!user?.is_host &&  pendingRequest > 0 && text == 'Pending requests' && <NotificationByPlaceBadge count={pendingMessages} />}



      </Link>
    </li>
  );
};

export default TabLink;
